import PriceForm from '@Forms/PriceForm';

class PriceSection extends React.Component {

    static modelToState(props) {
        return {
            Price: props.model.Price == 0 ? "" : props.model.Price,
            ForSale: props.model.ForSale,
            LeasePrice: props.model.LeasePrice == 0 ? "" : props.model.LeasePrice,
            ForLease: props.model.ForLease,
            ForFractional: props.model.ForFractional,
            FractionalPrice: props.model.FractionalPrice == 0 ? "" : props.model.FractionalPrice,
            FractionalOwnershipPercentages: props.model.FractionalOwnershipPercentages,
            FractionalPercent: props.model.FractionalPercent,
            CurrencyCodeSelected: props.model.CurrencyCodeSelected,
            CurrencyCodeList: props.model.CurrencyCodeList,
            DSInventoryLookupID: props.model.DSInventoryLookupID,
            ValidFECategory: props.model.ValidFECategory,
            FELink: props.model.FELink,
            ShowFE: props.model.ShowFE,
            TopLevelDomain: props.model.TopLevelDomain,
            ExcludeGoodsAndServicesTax: props.model.ExcludeGoodsAndServicesTax,
            ExcludeGoodsAndServicesTaxType: props.model.ExcludeGoodsAndServicesTaxType,
            ExcludeGoodsAndServicesTaxExistingSetting: props.model.ExcludeGoodsAndServicesTaxExistingSetting,
            FEClicks: props.model.FEClicks,
            priceEvaluation: [],
            EquipmentEventTypeID: props.model.EquipmentEventTypeID,
            EquipmentNumberOfResults: props.model.EquipmentNumberOfResults,
            EquipmentHigh: props.model.EquipmentHigh,
            EquipmentLow: props.model.EquipmentLow,
            EquipmentAverage: props.model.EquipmentAverage,
            EquipmentAverageWithoutHighAndLow: props.model.EquipmentAverageWithoutHighAndLow,
            AuctionEventTypeID: props.model.AuctionEventTypeID,
            AuctionNumberOfResults: props.model.AuctionNumberOfResults,
            AuctionHigh: props.model.AuctionHigh,
            AuctionLow: props.model.AuctionLow,
            AuctionAverage: props.model.AuctionAverage,
            AuctionAverageWithoutHighAndLow: props.model.AuctionAverageWithoutHighAndLow,
            TradeInHigh: props.model.TradeInHigh,
            TradeInLow: props.model.TradeInLow,
            DailyRentalPrice: props.model.DailyRentalPrice == 0 ? "" : props.model.DailyRentalPrice,
            WeeklyRentalPrice: props.model.WeeklyRentalPrice == 0 ? "" : props.model.WeeklyRentalPrice,
            MonthlyRentalPrice: props.model.MonthlyRentalPrice == 0 ? "" : props.model.MonthlyRentalPrice,
            QueryString: props.model.QueryString,
            NextPageURL: props.model.NextPageURL,
            Translations: props.model.Translations,
            Progress: props.model.Progress,
            PageNames: props.model.PageNames,
            ClassNamesForProgressBar: props.model.ClassNamesForProgressBar,
            CurrentSite: props.model.CurrentSite,
            ForSale: props.model.ForSale,
            FormattedPrice: props.model.FormattedPrice,
            FormattedLeasePrice: props.model.FormattedLeasePrice,
            FormattedFractionalPrice: props.model.FormattedFractionalPrice,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {}
        };
    }

    constructor(props) {
        super(props);

        this.state = PriceSection.modelToState(props);

        this.handleFormUpdate = this.handleFormUpdate.bind(this);

        //updates the parent's validator to use this method 
        this.validatorPrice = this.validatorPrice.bind(this);
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorPrice = this.validatorPrice;
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;
        this.props.handleFormUpdate(masterViewState);

    }

    validatorPrice(bSaveXML, field, e, bIsValue) {
        
        var state = this.state;
        if (field != null) {
            if (bIsValue) {
                state[field] = e;
            }
            else {
                state[field] = e.target.value;
            }
        }

        var highlightErrors = {};
        var formErrors = [];
        var inputErrors = {};
        var bHasErrors = false;
        var firstPriceErrorID = "";

        //check validations
        var onlyNumbers = /^[0-9., ]+$/.test(state.Price);
        if (!onlyNumbers && state.Price != "") {
            firstPriceErrorID = "Price";
            highlightErrors.Price = true;
            inputErrors.Price = state.Translations["MustNumber"].replace("{0}", state.Translations["Price"]);
        }

        if (state.CurrentSite == "Controller" || state.CurrentSite == "Aviation Trader" || state.CurrentSite == "Controller EMEA") {
            onlyNumbers = /^[0-9., ]+$/.test(state.LeasePrice);
            if (!onlyNumbers && state.LeasePrice != "") {
                if (firstPriceErrorID == "") {
                    firstPriceErrorID = "Lease";
                }
                highlightErrors.LeasePrice = true;
                inputErrors.LeasePrice = state.Translations["MustNumber"].replace("{0}", state.Translations["MonthlyPrice"]);
            }
            onlyNumbers = /^[0-9., ]+$/.test(state.FractionalPrice);
            if (!onlyNumbers && state.FractionalPrice != "") {
                if (firstPriceErrorID == "") {
                    firstPriceErrorID = "Fractional";
                }
                highlightErrors.FractionalPrice = true;
                inputErrors.FractionalPrice = state.Translations["MustNumber"].replace("{0}", state.Translations["FractionalOwnershipPrice"]);
            }
            if (state.ForFractional) {
                if ((state.FractionalPrice != "0" && state.FractionalPrice != "") &&
                   (state.FractionalPercent == "0" || state.FractionalPercent == "")) {
                    if (firstPriceErrorID == "") {
                        firstPriceErrorID = "Fractional";
                    }
                    highlightErrors.FractionalPercent = true;
                    inputErrors.FractionalPercent = "Please select a percentage.";
                }
                else if ((state.FractionalPercent != "0" && state.FractionalPercent != "") &&
                          (state.FractionalPrice == "0" || state.FractionalPrice == "")) {
                    if (firstPriceErrorID == "") {
                        firstPriceErrorID = "Fractional";
                    }
                    highlightErrors.FractionalPrice = true;
                    inputErrors.FractionalPrice = "Please enter a price or clear the percentage.";
                }
            }
        }

        if (!this.props.masterViewModel.IsConsignment) {
            if (!highlightErrors.Price && state.Price != "") {
                var objectToSend = {
                    oPriceViewModel: {
                        CurrencyCodeSelected: state.CurrencyCodeSelected,
                        Price: state.Price
                    },
                    WhichPrice: "ForSale"
                };

                var xhr1 = new XMLHttpRequest();
                xhr1.onload = function () {
                    var response = JSON.parse(xhr1.response);
                    if (response.sFormattedPrice == "" && state.Price != "") {
                        firstPriceErrorID = "Price";
                        highlightErrors.Price = true;
                        inputErrors.Price = state.Translations["InvalidPrice"];
                    }
                    state.FormattedPrice = response.sFormattedPrice;
                }.bind(this);

                xhr1.open("POST", '/listinginput/price/GetFormattedPrice' + this.state.QueryString, false);
                xhr1.setRequestHeader("Content-type", "application/json");
                xhr1.send(JSON.stringify(objectToSend));
            }
            if (state.CurrentSite == "Controller" || state.CurrentSite == "Aviation Trader" || state.CurrentSite == "Controller EMEA") {
                if (!highlightErrors.LeasePrice && state.LeasePrice != "") {
                    var objectToSend = {
                        oPriceViewModel: {
                            CurrencyCodeSelected: state.CurrencyCodeSelected,
                            LeasePrice: state.LeasePrice
                        },
                        WhichPrice: "ForLease"
                    };

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        var response = JSON.parse(xhr1.response);
                        if (response.sFormattedPrice == "" && state.LeasePrice != "") {
                            if (firstPriceErrorID == "") {
                                firstPriceErrorID = "Lease";
                            }
                            highlightErrors.LeasePrice = true;
                            inputErrors.LeasePrice = state.Translations["InvalidPrice"];
                        }
                        state.FormattedLeasePrice = response.sFormattedPrice;
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/price/GetFormattedPrice' + this.state.QueryString, false);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
                if (!highlightErrors.FractionalPrice && state.FractionalPrice != "") {
                    var objectToSend = {
                        oPriceViewModel: {
                            CurrencyCodeSelected: state.CurrencyCodeSelected,
                            FractionalPrice: state.FractionalPrice
                        },
                        WhichPrice: "ForFractional"
                    };

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        var response = JSON.parse(xhr1.response);
                        if (response.sFormattedPrice == "" && state.FractionalPrice != "") {
                            if (firstPriceErrorID == "") {
                                firstPriceErrorID = "Fractional";
                            }
                            highlightErrors.FractionalPrice = true;
                            inputErrors.FractionalPrice = state.Translations["InvalidPrice"];
                        }
                        state.FormattedFractionalPrice = response.sFormattedPrice;
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/price/GetFormattedPrice' + this.state.QueryString, false);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
            }
        }

        if (Object.keys(inputErrors).length != 0) {
            bHasErrors = true;

            //calculate location of error message hidden element
            var selector
            if (firstPriceErrorID == "Price") {
                selector = document.getElementById(firstPriceErrorID);
            }
            else if (firstPriceErrorID == "Lease") {
                selector = document.getElementById("addtlPrice-groupName-1");
            }
            else {
                selector = document.getElementById("addtlPrice-groupName-2");
            }

            if ($(".price-options-2").is(':hidden') && firstPriceErrorID != "Price") {
                PriceOptionsToggle();
            }
            if ($(selector).is(':hidden')) {
                if (state.CurrentSite == "Controller" || state.CurrentSite == "Aviation Trader" || state.CurrentSite == "Controller EMEA") {
                    $(selector).slideToggle(400);
                }
                $(selector).addClass("expanded");
                $(selector).removeClass("closed");
            }

            var elemTop = $(selector).offset().top;
            var elemBottom = elemTop + $(selector).height();
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            if ((elemBottom > docViewBottom) || (elemTop < docViewTop)) {
                $('html, body').animate({
                    scrollTop: ($(selector).offset().top - 100)
                }, 500);
            }
        }
        else {
            if (bSaveXML) {

                //update master view model
                var masterViewState = this.props.masterViewModel;
                masterViewState.PriceViewModel = state;
                this.props.handleFormUpdate(masterViewState);
            }
            bHasErrors = false;
        }

        this.setState({
            HighlightErrors: highlightErrors,
            InputErrors: inputErrors,
            FormErrors: formErrors,
        });

        return bHasErrors
    }

    handleFormUpdate(Model) {
        this.setState({
            Price: Model.Price,
            ForSale: Model.ForSale,
            LeasePrice: Model.LeasePrice,
            ForLease: Model.ForLease,
            ForFractional: Model.ForFractional,
            FractionalPrice: Model.FractionalPrice,
            FractionalPercent: Model.FractionalPercent,
            FractionalOwnershipPercentages: Model.FractionalOwnershipPercentages,
            ForSale: Model.ForSale,
            CurrencyCodeSelected: Model.CurrencyCodeSelected,
            CurrencyCodeList: Model.CurrencyCodeList,
            DSInventoryLookupID: Model.DSInventoryLookupID,
            ValidFECategory: Model.ValidFECategory,
            FELink: Model.FELink,
            ShowFE: Model.ShowFE,
            TopLevelDomain: Model.TopLevelDomain,
            ExcludeGoodsAndServicesTax: Model.ExcludeGoodsAndServicesTax,
            FEClicks: Model.FEClicks,
            priceEvaluation: Model.priceEvaluation,
            EquipmentEventTypeID: Model.EquipmentEventTypeID,
            EquipmentNumberOfResults: Model.EquipmentNumberOfResults,
            EquipmentHigh: Model.EquipmentHigh,
            EquipmentLow: Model.EquipmentLow,
            EquipmentAverage: Model.EquipmentAverage,
            EquipmentAverageWithoutHighAndLow: Model.EquipmentAverageWithoutHighAndLow,
            AuctionEventTypeID: Model.AuctionEventTypeID,
            AuctionNumberOfResults: Model.AuctionNumberOfResults,
            AuctionHigh: Model.AuctionHigh,
            AuctionLow: Model.AuctionLow,
            AuctionAverage: Model.AuctionAverage,
            AuctionAverageWithoutHighAndLow: Model.AuctionAverageWithoutHighAndLow,
            TradeInHigh: Model.TradeInHigh,
            TradeInLow: Model.TradeInLow,
            DailyRentalPrice: Model.DailyRentalPrice,
            WeeklyRentalPrice: Model.WeeklyRentalPrice,
            MonthlyRentalPrice: Model.MonthlyRentalPrice,
            QueryString: Model.QueryString,
            Translations: Model.Translations,
            NextPageURL: Model.NextPageURL,
            Progress: Model.Progress,
            PageNames: Model.PageNames,
            ClassNamesForProgressBar: Model.ClassNamesForProgressBar,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            FormattedPrice: Model.FormattedPrice,
            FormattedLeasePrice: Model.FormattedLeasePrice,
            FormattedFractionalPrice: Model.FormattedFractionalPrice
        });
    }

    handleOnBlur(field, e, bIsValue) {
        this.validatorPrice(true, field, e, bIsValue);
        //update master view 
        this.handleMasterViewUpdate(this.state);
    }

    //Updates ViewModels in the Master View, then the MasterView will pass it down to the other child react components
    handleMasterViewUpdate(Model) {
        var masterViewModel = this.props.masterViewModel;
        masterViewModel.PriceViewModel = Model;
        this.props.handleFormUpdate(masterViewModel);
    }

    render() {
        return (
            <div style = {{ marginBottom: '25px' }} >
                <PriceForm
                    model={this.state}
                    masterViewModel={this.props.masterViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    handleMasterViewUpdate={(e) => { this.handleMasterViewUpdate(e); }}
                    handleOnBlur={(field, value, bIsValue) => { this.handleOnBlur(field, value, bIsValue); }}
                />
            </div>
        );
    }
}

export default PriceSection;
global.PriceSection = PriceSection;